import { ReactElement } from 'react'
import { Button, Container, SVG, SVGs } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { useBFSM } from '../../../contexts/bfsmContext'
import { Props } from './props'
import { RenderIf } from '../higherOrderComponents/renderIf'
import { useAppSelector } from '../../../redux/hooks'
import { getIsLoading } from '../../../redux/reducers/appSettings'

const BackButton = ({ hideBackButton, onClickBack }: Props): ReactElement => {
    const [BFSM] = useBFSM()
    const { t } = useTranslation()
    const isLoading = useAppSelector((state) => getIsLoading(state))
    return (
        <RenderIf condition={!hideBackButton}>
            <Container>
                <Button
                    css={{ px: '$2' }}
                    data-cy="backBtn"
                    onClick={onClickBack ?? BFSM.goBack}
                    size="small"
                    startIcon={<SVG src={SVGs.ChevronLeft} />}
                    variant="plain"
                    disabled={isLoading}
                >
                    {t('common:back')}
                </Button>
            </Container>
        </RenderIf>
    )
}

export default BackButton
